// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {Checkbox, FormControl, FormHelperText, Input, InputLabel, Select, Stack, Typography} from "@mui/material";

// App Imports

import DynamicMultiSelectDropdown from "../../../../CommonComponents/DynamicMultiSelectDropdown";
import MenuItem from "@mui/material/MenuItem";
import DynamicMultiSelectGridNarrow from "../../../../CommonComponents/DynamicMultiSelectGridNarrow";
import {changeContractDrilldownCS} from "../../contractDrilldownSliceCS";



// Main Function
export default function QueryFinancialsGridVersionNarrow(fetchDataPoints) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;

    const filteringMethodDropdown = ["","Has","Does Not Have"];
    const parentItemDropdown = ["","Gross Receipts","Allowed Expenses"];
    const [clearAll, setClearAll] = useState(false);
    const [selectedFilteringMethod, setSelectedFilteringMethod] = useState('');
    const [selectedParentItem, setSelectedParentItem] = useState('');
    // ****************** END STORE ****************************

    // ****************** BEGIN SELECTORS ****************************

    // ****************** END SELECTORS ****************************


    // ****************** BEGIN CLOSE ***************************
    function closeQfDrawer() {
        dispatchData(changeContractDrilldownCS({QfDrawerState: false }));
    };
// ******************** END CLOSE ********************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************


    // ****************** END CRUD ****************************


    // ****************** BEGIN MISC ****************************

    // ****************** END MISC ****************************


    const handleClearAll = () => {
        setClearAll(!clearAll);
        setSelectedFilteringMethod(null);
        // setClearAll = !clearAll;
        console.log("Clear All button clicked");
    };

    const handleFilteringMethodChange = (filteringMethodEvent) => {
        setSelectedFilteringMethod(filteringMethodEvent.target.value);
        console.log("This is for the selected Value");
        console.log(filteringMethodEvent.target.value);
    };


    const handleParentItemChange = (event) => {
        setSelectedParentItem(event.target.value);
        console.log("This is for the selected Parent Item");
        console.log(event.target.value);
    };


    // ****************** BEGIN RETURN ****************************

    return (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >

            <Box
                sx={{ width: 1800 , height: 800, pl: 5}}
                role="presentation"
            >
                <br/>
                <br/>
                <Stack direction="row" spacing={60}     alignItems="center" >
                    <Button  onClick={() => handleClearAll()} >Clear All</Button>
                    <Stack direction="row" spacing={4}     alignItems="center" >
                        <Typography sx={{pl:1}} fontWeight={"bold"} >Parent Item </Typography>
                        <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                            {/*<InputLabel sx={{ ml: 1}} htmlFor="filteringMethod">Data Set</InputLabel>*/}


                            <Select
                                {...register('parentItem', { required: false })}
                                labelId="demo-simple-select-filled-parentItem"
                                id="parentItem"
                                // FreeSolo={true}
                                // variant="filled"
                                label="parentItem"
                                value={selectedParentItem}
                                onChange={handleParentItemChange}
                                sx={{ width: 200}}
                            >
                                {parentItemDropdown.map((Item) =>
                                    <MenuItem
                                        // FreeSolo={true}
                                        value={Item}>{Item}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Stack>
                </Stack>
                <br/>
                <br/>
                {/*<br/>*/}
                <Stack direction="row" spacing={4}     alignItems="center" >
                    <Typography sx={{pl:1}} fontWeight={"bold"} >Account... </Typography>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 150 }} >
                        {/*<InputLabel sx={{ ml: 1}} htmlFor="filteringMethod">Data Set</InputLabel>*/}


                        <Select
                            {...register('filteringMethod', { required: false })}
                            labelId="demo-simple-select-filled-filteringMethod"
                            id="filteringMethod"
                            // FreeSolo={true}
                            // variant="filled"
                            label="filteringMethod"
                            value={selectedFilteringMethod}
                            onChange={handleFilteringMethodChange}
                            sx={{ width: 150}}
                        >
                            {filteringMethodDropdown.map((Item) =>
                                <MenuItem
                                    // FreeSolo={true}
                                    value={Item}>{Item}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Stack>
                <br/>
                <Stack direction="row" spacing={4} >
                    <DynamicMultiSelectGridNarrow
                        selectorDataPointId ={12023}
                        selectorLabel = "Account"
                        clearAll = {clearAll}
                    />
                    <br/>
                    <br/>
                    <DynamicMultiSelectGridNarrow
                        selectorDataPointId ={12025}
                        selectorLabel = "Market"
                        clearAll = {clearAll}
                    />
                    <br/>
                    <br/>
                    <DynamicMultiSelectGridNarrow
                        selectorDataPointId ={12027}
                        selectorLabel = "Distribution Channel"
                        clearAll = {clearAll}
                    />
                    <br/>
                    <br/>
                    <DynamicMultiSelectGridNarrow
                        selectorDataPointId ={12020}
                        selectorLabel = "Region"
                        clearAll = {clearAll}
                    />
                    <br/>
                    <br/>
                    <DynamicMultiSelectGridNarrow
                        selectorDataPointId ={12019}
                        selectorLabel = "Country"
                        clearAll = {clearAll}
                    />
                    <br/>
                    <br/>
                    <DynamicMultiSelectGridNarrow
                        selectorDataPointId ={12022}
                        selectorLabel = "Language"
                        clearAll = {clearAll}
                    />
                </Stack>
                <br/>
                <br/>
                <br/>
                <Button
                    type= "submit"
                >Submit</Button>
                <Button onClick={() => closeQfDrawer()}>Cancel</Button>
            </Box>
        </form>
    );

    // ****************** END RETURN ****************************

}
